import Loadable from 'react-loadable';

import CrossOperatorDepositLimitForm from './components/CrossOperatorDepositLimit/CrossOperatorDepositLimitForm';
import ESGamingLimitForm from './components/ESGamingLimit/ESGamingLimitForm/ESGamingLimitForm';
import LoginTimeZone from './components/LoginTimeZone/LoginTimeZone';
import NotificationContainer from './components/NotificationContainer/NotificationContainer';
import PlayingLimitsReminderContent from './components/PlayingLimitsReminderContent/PlayingLimitsReminderContent';
import SelfExcludedBrandsList from './components/SelfExcluded/SelfExcludedUK/SelfExcludedBrandsList/SelfExcludedBrandsList';
import ServerMessageHandler from './components/ServerMessageHanlder/ServerMessageHandler';
import AMLSuspended from './components/VerifyAccount/components/AMLSuspended';
import styles from './styles/styles.scss';

const StarsNotification = Loadable({
  loader: () => import(/* webpackChunkName: "StarsNotification" */ './StarsNotification'),
  modules: ['./StarsNotification'],
  loading: () => null
});

export {
  AMLSuspended,
  LoginTimeZone,
  NotificationContainer,
  PlayingLimitsReminderContent,
  SelfExcludedBrandsList,
  ServerMessageHandler,
  StarsNotification,
  ESGamingLimitForm,
  CrossOperatorDepositLimitForm,
  styles
};
